import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { validate } from 'rut.js'; // Assuming this is your RUT validation library

// Material-UI Components for a better look
import {
    Box,
    Button,
    Typography,
    Modal,
    TextField,
    Divider,
    Card,
    CardContent,
    Grid,
    IconButton,
    Alert,
    Collapse // For the alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // For close button on alert

// Your custom CSS
import "../modal.css"; // Ensure this CSS aligns with new structure
import LogoRFID from "../../Imagenes/logorfid.png";

// Styles for the modal
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '70%', md: '50%' }, // Responsive width
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2, // Rounded corners
    outline: 'none', // Remove default outline
};

export default function BasicModal() {
    const URI = "https://invio.datachile.site/Web/Usuarios/AgregarUsuario.php";
    const navigate = useNavigate();

    // State for form fields
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');     // Correo Electrónico
    const [usuario, setUsuario] = useState('');   // NEW: Nombre de Usuario
    const [rut, setRut] = useState('');
    const [clave, setClave] = useState('');
    const [empresa_idEmpresa, setEmpresaIdEmpresa] = useState('');

    // State for validation errors and alerts
    const [rutError, setRutError] = useState('');
    const [formError, setFormError] = useState(''); // General form validation error
    const [alertOpen, setAlertOpen] = useState(false); // For showing success/error alerts

    // Modal open/close state
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        // Reset form and errors when opening
        setNombre('');
        setCorreo('');
        setUsuario('');  // Reset new user field
        setRut('');
        setClave('');
        setRutError('');
        setFormError('');
        setAlertOpen(false);
        setOpen(true);
    };
    const handleClose = () => setOpen(false);

    // Effect to get empresa_idEmpresa from localStorage on component mount
    useEffect(() => {
        const usuarioData = JSON.parse(localStorage.getItem('usuario')); // Renamed to avoid conflict
        if (usuarioData && usuarioData.empresa_idEmpresa) {
            setEmpresaIdEmpresa(usuarioData.empresa_idEmpresa);
            console.log('empresa_idEmpresa from localStorage:', usuarioData.empresa_idEmpresa);
        } else {
            console.warn('empresa_idEmpresa not found in localStorage. User might not be logged in.');
        }
    }, []);

    // Function to handle form submission
    const Guardar = async (e) => {
        e.preventDefault();

        setFormError(''); // Clear previous form errors
        setRutError(''); // Clear previous RUT errors
        setAlertOpen(false); // Hide any previous alerts

        // --- Frontend Validation ---
        // Validate required fields (now including 'usuario' and 'correo')
        if (!nombre || !correo || !usuario || !rut || !clave) {
            setFormError('Por favor, complete todos los campos.');
            setAlertOpen(true);
            return;
        }

        // Validate RUT
        if (!validate(rut)) {
            setRutError('RUT no válido');
            setFormError('RUT no válido.');
            setAlertOpen(true);
            return;
        }

        // --- Data to send to Backend ---
        const data = {
            nombre: nombre,
            correo: correo,
            usuario: usuario, // Sending 'usuario' field
            rut: rut,
            clave: clave,
            empresa_idEmpresa: empresa_idEmpresa,
        };
        console.log('Data being sent to API:', data);

        try {
            // Realizar la solicitud POST
            const res = await axios.post(URI, data);
            console.log('Response from API:', res.data);

            // Mostrar mensaje de éxito
            alert('Usuario guardado exitosamente.'); // Using native alert for consistency with your existing code

            // Cerrar el modal
            handleClose();

            // Reiniciar los valores del formulario
            setNombre('');
            setCorreo('');
            setUsuario(''); // Reset new user field
            setRut('');
            setClave('');

            // Force a full page reload to show updated user list
            window.location.reload();

        } catch (error) {
            console.error('Error al guardar usuario:', error);
            // Handle different types of errors from the API
            if (error.response) {
                const errorMessage = error.response.data.message || 'Error desconocido al guardar el usuario.';
                setFormError(`Error: ${errorMessage}`);
            } else if (error.request) {
                setFormError('Error de red: No se pudo conectar con el servidor.');
            } else {
                setFormError('Error desconocido al configurar la solicitud.');
            }
            setAlertOpen(true); // Show the error alert
        }
    };

    return (
        <div>
            <Button
                variant="contained"
                sx={{
                    ml: { xs: 0, md: '57%' }, // Adjust margin for responsiveness
                    height: 50,
                    mt: { xs: 2, md: 0 }, // Add margin top for smaller screens
                    width: { xs: '100%', sm: 'auto' } // Full width on small screens
                }}
                onClick={handleOpen}
            >
                Agregar Usuario
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title-add-user"
                aria-describedby="modal-description-add-user"
            >
                <Box sx={modalStyle}>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                            <Typography id="modal-title-add-user" variant="h5" component="h2" sx={{ mb: 2 }}>
                                Agregar Nuevo Usuario
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IconButton onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Divider sx={{ mb: 3 }} /> {/* Increased margin bottom */}

                    <Collapse in={alertOpen}>
                        {formError && (
                            <Alert
                                severity="error"
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => setAlertOpen(false)}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                sx={{ mb: 2 }}
                            >
                                {formError}
                            </Alert>
                        )}
                    </Collapse>

                    <form onSubmit={Guardar}>
                        <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
                            {/* Left side: Form Inputs */}
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    id="input-nombre"
                                    label="Nombre"
                                    variant="outlined"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    required
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    id="input-rut"
                                    label="RUT"
                                    variant="outlined"
                                    value={rut}
                                    onChange={(e) => {
                                        setRut(e.target.value);
                                        setRutError(''); // Clear error on change
                                    }}
                                    error={rutError !== ''}
                                    helperText={rutError}
                                    required
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    id="input-correo"
                                    label="Correo Electrónico"
                                    variant="outlined"
                                    type="email"
                                    value={correo}
                                    onChange={(e) => setCorreo(e.target.value)}
                                    required
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    id="input-usuario" // NEW: ID for Usuario field
                                    label="Nombre de Usuario" // NEW: Label for Usuario field
                                    variant="outlined"
                                    value={usuario}
                                    onChange={(e) => setUsuario(e.target.value)}
                                    required
                                />
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    id="input-password"
                                    label="Contraseña"
                                    type='password'
                                    variant="outlined"
                                    value={clave}
                                    onChange={(e) => setClave(e.target.value)}
                                    required
                                />

                                {/* Action Buttons */}
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
                                    <Button
                                        type='button'
                                        variant="outlined"
                                        onClick={handleClose}
                                        color="error"
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        type='submit'
                                        variant="contained"
                                        color="primary"
                                    >
                                        Guardar
                                    </Button>
                                </Box>
                            </Grid>
 {/* Right side: Image (optional) */}
 <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Card sx={{ width: '100%', maxWidth: 300, mt: { xs: 4, md: 0 } }}>
                                    <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
                                        <img src={LogoRFID} alt="Logo RFID" style={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        
                        </Grid>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}